<template>
  <div v-loading="loading" class="device-plan-library" :class="showUploadDailog ? 'device-plan-library-dialog' : ''">
    <div class="border_title">
      {{ $t('tianmu.lightLibrary') }}
    </div>
    <div class="device-plan-library_content">
      <div class="device-plan-library_tab">
        <div class="tabs_img" :class="{ active: activeTab === 'static' }" @click="activeTab = 'static'">
          {{ $t('tianmu.static') }}
        </div>
        <div
          v-if="isShowDynamic"
          class="tabs_video"
          :class="{ active: activeTab === 'dynamic' }"
          @click="activeTab = 'dynamic'"
        >
          {{ $t('tianmu.dynamic') }}
        </div>
        <div
          v-if="!isIot1() && !isIot3()"
          class="tabs_video"
          :class="{ active: activeTab === 'ai' }"
          @click="activeTab = 'ai'"
        >
          AI
        </div>
      </div>
      <TianMuImgPlanLibrary
        v-if="showTianMu && activeTab === 'static'"
        :model="model"
        :device-card-list="childDeviceList"
        :PlanId="PlanId"
      />
      <TianMuVideoPlanLibrary
        v-if="showTianMu && activeTab === 'dynamic' && isShowDynamic"
        :model="model"
        :device-card-list="childDeviceList"
        :PlanId="PlanId"
        :web-container="webContainer"
        :action-list="flatActionList"
        :show-mode="showMode"
      />
      <div style="padding: 0 40px;">
        <AiPic v-if="!isIot1() && !isIot3() && activeTab==='ai' && model && model.Gpno" :device="model" from="tianmu" />
      </div>
    </div>
  </div>
</template>
<script>
import AiPic from '../OppleFeiFan/AiPic.vue';
import TianMuImgPlanLibrary from '@/components/OppleDeviceTianMu/TianMuImgPlanLibrary.vue'
import TianMuVideoPlanLibrary from '@/components/OppleDeviceTianMu/TianMuVideoPlanLibrary.vue'
import { GetPlanInfoDetail } from '@/axios/IDevice.js'
import { alerterror, warning, alertsuccess } from '@/assets/js/common.js'
import TianmuProxy from '@/page/tianmu-design/canvas/CanvasMain/lib/TianmuProxy'
import {
  Finduiability
} from '@/axios/IDevice.js'
import { isIot1, isIot3 } from '@utils/utils'

export default {
  components: {
    TianMuImgPlanLibrary,
    TianMuVideoPlanLibrary,
    AiPic
  },
  props: {
    showTianMu: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: () => {},
    },
    childDeviceList: {
      type: Array,
      default: () => [],
    },
    PlanId: {
      type: String,
      default: '',
    },
    webContainer: {
      type: Object,
      default: () => null,
    },
    actionList: {
      type: Array,
      default: () => [],
    },
    showMode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeTab: 'static', // 默认选中“静态”
      showUploadDailog: false, //显示上传弹窗
      loading: false,
      isShowDynamic:true
    }
  },
  computed: { 
    flatActionList(){
      return this.actionList.flatMap(item => item.ActionList)
    }
  },
  watch: {
    async PlanId() {
      try {
        const { StatusCode, Result } = await GetPlanInfoDetail({ planId: this.PlanId })

        if (StatusCode !== this.$store.state.rightStatusCode) {
          alerterror(this, StatusCode)
        }
        const tianmuProxy = new TianmuProxy(Result)

        this.$emit('isTianmuPlanCustom', tianmuProxy.isCustom)
        const controllers = tianmuProxy.controllers
        const channels = controllers[0]?.channelCount || 1

        const isNew = await this.isNew();

        if (controllers.length > 1 || channels === 1 || isNew === false){
          this.isShowDynamic = false
        }
      } catch (error) {
        console.error('getIsNew=====:', error)
      }
    },
  },

  methods: {
    isIot1,
    isIot3,
    async isNew() {
      debugger
      const res = await Finduiability({ vDeviceId: this.model?.VDeviceId });

        if (res?.Result?.UIConfigV2?.TianMuVideoVersion === 2) {
          return true;
        }

        return false;
    },
  },
}
</script>
<style lang="scss" scoped>
.device-plan-library {
  &_content {
    border: 2px solid #e1e3e6;
  }
  &_tab {
    display: flex;
    margin-left: 40px;
    margin-top: 40px;
    //margin-bottom: 10px;
    &>div {
      margin-right: 20px;
    }
    .tabs_img {
      padding-bottom: 10px;
      text-align: center;
      cursor: pointer;
      color: #333333;
      opacity: 0.5;
    }
    .tabs_video {
      padding-bottom: 10px;
      text-align: center;
      cursor: pointer;
      color: #333333;
      opacity: 0.5;
    }
    .active {
      font-weight: bold;
      opacity: 1;
      color: #333333;
      border-bottom: 2px solid #007bff;
    }
  }
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
}
</style>
